import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/optimism-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-7d994664"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "network",
  href: "https://app.optimism.io/bridge",
  target: "_blank"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "optimism-logo",
  src: _imports_0,
  alt: "Optimism"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Optimism", -1))

import { ArrowTopRightOnSquareIcon } from '@heroicons/vue/20/solid';
import { computed } from 'vue';
import { useClaimStore } from '@/store/claimStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'OptimismBanner',
  setup(__props) {

const store = useClaimStore();

const linkLabel = computed(() => {
  if (store.cost.eq(0)) {
    return 'Claiming on';
  } else {
    return 'Purchasing on';
  }
});

return (_ctx: any,_cache: any) => {
  return (_unref(store).networkId === 10)
    ? (_openBlock(), _createElementBlock("a", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_unref(linkLabel)), 1),
        _hoisted_2,
        _hoisted_3,
        _createVNode(_unref(ArrowTopRightOnSquareIcon), { class: "link-icon" })
      ]))
    : _createCommentVNode("", true)
}
}

})